import { render } from "./Twitter.vue?vue&type=template&id=0b189b1c"
const script = {}
script.render = render

export default script